/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-field--row[_ngcontent-%COMP%]{margin-bottom:2.5rem}.title-h2[_ngcontent-%COMP%] + div.no-padding[_ngcontent-%COMP%]     .label{margin-top:0}  .checkbox-wrapper{margin-bottom:1rem}.button.full-width[_ngcontent-%COMP%]{margin-top:1rem}  .select-wrapper{margin-bottom:.5rem}.sidebar-wrapper[_ngcontent-%COMP%]{height:calc(100% - 60px);overflow:auto}"];
export { styles as styles };
